import { render, staticRenderFns } from "./updatePassword.vue?vue&type=template&id=5ff61d88&scoped=true"
import script from "./updatePassword.vue?vue&type=script&lang=js"
export * from "./updatePassword.vue?vue&type=script&lang=js"
import style0 from "./updatePassword.vue?vue&type=style&index=0&id=5ff61d88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff61d88",
  null
  
)

export default component.exports